import { Box, Stack,Text } from "@chakra-ui/react";
import React from "react";
import { InputRowGrid } from "../../shared/InputRowGrid";
import RadioGroup from "../RadioCardBox";
import { ImProfile } from "react-icons/im";
import TagsInput from "../../shared/Taginput";

export default function JobDetails() {
  return (
    <Stack gap={5}>
      <InputRowGrid
        heading="Type of Project"
        input={<RadioGroup options={projectOptions} />}
      />
      <InputRowGrid
        heading={"Screening Questions"}
        text={"Add screening questions and/or require a cover letter"}
        input={
          <Stack gap={5}>
            <TagsInput />
            <Box color='#676767'>
              <Text align="start" fontWeight="semibold" fontSize={{base:"17px",md:"22px"}}>Cover letter</Text>
              <Text align="start" mt={1} fontSize={{base:"16px",md:"20px"}}>If you don't add any screening questions, we'll require a cover letter to allow freelancers and agencies to introduce themselves.</Text>
            </Box>
          </Stack>
        }
      />
    </Stack>
  );
}
const projectOptions = [
  {
    heading: "One-Time Project",
    text: "Find the right skills for a short-term need",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28.558"
        height="28.557"
        viewBox="0 0 28.558 28.557"
      >
        <g
          id="Group_533"
          data-name="Group 533"
          transform="translate(-1410.221 -202.721)"
        >
          <g
            id="employee_1_"
            data-name="employee (1)"
            transform="translate(1410.221 202.721)"
          >
            <path
              id="Path_1222"
              data-name="Path 1222"
              d="M9.949,11.9A5.949,5.949,0,1,1,15.9,5.949,5.956,5.956,0,0,1,9.949,11.9Zm0-10.114a4.165,4.165,0,1,0,4.165,4.165A4.169,4.169,0,0,0,9.949,1.785Z"
              transform="translate(0.76)"
              fill="#888"
            />
            <path
              id="Path_1223"
              data-name="Path 1223"
              d="M11.006,22.709H.892A.893.893,0,0,1,0,21.817V17.652A5.659,5.659,0,0,1,5.652,12H15.766a.892.892,0,1,1,0,1.785H5.652a3.872,3.872,0,0,0-3.867,3.867v3.272h9.222a.892.892,0,1,1,0,1.785Z"
              transform="translate(0 2.279)"
              fill="#888"
            />
            <path
              id="Path_1224"
              data-name="Path 1224"
              d="M24.2,25.519H14.082A2.085,2.085,0,0,1,12,23.437V18.082A2.085,2.085,0,0,1,14.082,16H24.2a2.085,2.085,0,0,1,2.082,2.082v5.354A2.085,2.085,0,0,1,24.2,25.519ZM14.082,17.785a.3.3,0,0,0-.3.3v5.354a.3.3,0,0,0,.3.3H24.2a.3.3,0,0,0,.3-.3V18.082a.3.3,0,0,0-.3-.3Z"
              transform="translate(2.279 3.038)"
              fill="#888"
            />
            <path
              id="Path_1225"
              data-name="Path 1225"
              d="M21.247,18.26a.893.893,0,0,1-.892-.892V15.582a.3.3,0,0,0-.3-.3H17.082a.3.3,0,0,0-.3.3v1.785a.892.892,0,1,1-1.785,0V15.582A2.085,2.085,0,0,1,17.082,13.5h2.975a2.085,2.085,0,0,1,2.082,2.082v1.785A.893.893,0,0,1,21.247,18.26Z"
              transform="translate(2.848 2.563)"
              fill="#888"
            />
            <path
              id="Path_1226"
              data-name="Path 1226"
              d="M19.139,21.76a.884.884,0,0,1-.383-.087L12.509,18.7a.893.893,0,0,1,.767-1.612l5.863,2.793L25,17.086A.893.893,0,0,1,25.77,18.7l-6.247,2.975A.892.892,0,0,1,19.139,21.76Z"
              transform="translate(2.279 3.228)"
              fill="#888"
            />
          </g>
        </g>
      </svg>
    ),
  },
  {
    heading: "Ongoing Project",
    text: "Find a skilled resource for an extended engagement.",
    icon: <ImProfile />,
  },
];
